export default __webpack_public_path__ + "static/media/account_manager.9e1809be.svg";